<template>
    <div id="progress-page">
        <div class="goal-panel">
            <h3>Savings Progress</h3>
            <template v-if="goalInfo">
                <div class="goal-progress">
                    <div class="text">
                        <p>Down Payment Goal</p>
                        <output>{{ goalInfo.amount|currency }}</output>
                        <p>Current Savings</p>
                        <output>{{ activeSavingsAccount.balances[0].amount|currency }}</output>
                        <p>Target Date</p>
                        <output>{{ goalInfo.date|fmtdate('MM/dd/yyyy') }}</output>
                    </div>
                    <div class="graphic">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 225 217.667">
                            <defs>
                                <clipPath id="outline">
                                    <path fill="none" stroke="#000000" stroke-width="2.5" stroke-miterlimit="10" d="M209.075,107.352L185,82.692v-32.1
                                        c0-1.657-0.538-1.926-2.195-1.926h-17c-1.657,0-3.805,0.269-3.805,1.926v8.663l-46.85-48.149c-1.656-1.655-4.138-1.717-5.794-0.062 
                                        l-93.827,96.338c-1.655,1.656-1.555,5.284,0.102,6.284H36v89.926c0,1.657,2.148,4.074,3.805,4.074h145
                                        c1.657,0,2.195-2.417,2.195-4.074v-89.926h22.478C211.133,112.667,210.73,109.008,209.075,107.352z"/>
                                </clipPath>
                                <filter id="inner-shadow">
                                    <feOffset in="SourceGraphic" dx="0" dy="0" transform="scale(0.9 0.9)" />
                                    <feGaussianBlur stdDeviation="5" result="blur2" />
                                    <feMerge>
                                        <feMergeNode in="blur2" />
                                        <feMergeNode in="SourceGraphic" />
                                    </feMerge>
                                </filter>
                            </defs>
                            <g>
                                <rect clip-path="url(#outline)" x="0" y="0" fill="white" width="225" height="216.667"/>
                                <rect clip-path="url(#outline)" x="0" :y="217.667 - goalHeight" fill="#F1E142" width="225" :height="goalHeight"/>
                                <path id="house" fill="none" stroke="#000000" stroke-width="2.5" stroke-miterlimit="10" d="M209.075,107.352L185,82.692v-32.1
                                    c0-1.657-0.538-1.926-2.195-1.926h-17c-1.657,0-3.805,0.269-3.805,1.926v8.663l-46.85-48.149c-1.656-1.655-4.138-1.717-5.794-0.062
                                    l-93.827,96.338c-1.655,1.656-1.555,5.284,0.102,6.284H36v89.926c0,1.657,2.148,4.074,3.805,4.074h145
                                    c1.657,0,2.195-2.417,2.195-4.074v-89.926h22.478C211.133,112.667,210.73,109.008,209.075,107.352z"/>
                                
                                <use clip-path="url(#outline)" xlink:href="#house" transform="scale(1)" filter="url(#inner-shadow)" />

                                <text x="50%" y="60%" text-anchor="middle">
                                {{ Number(goalHeight / 217.667 * 100).toFixed(0) }}%
                                </text>
                            </g>
                        </svg>
                    </div>
                </div>
                <div>
                    <router-link to="/main/set-goal" class="edit">Edit Your Goal</router-link>
                </div>
            </template>
            <template v-else>
                <div class="no-goal-set">
                    <p>You have not set a savings goal.</p>
                    <p>
                        <router-link to="/main/set-goal" class="edit">Set Your Goal</router-link>
                    </p>
                </div>
            
            </template>
        </div>
        <div class="chart-panel">
            <h3>Your Savings History</h3>
            <split-button :items="['Yearly', 'Monthly', 'Weekly']" @click="historyChange" />

            <svg ref="chart" class="chart">
            </svg>
            <div class="btn">
                <router-link to="/main/transfer-history" class="history">View Transfer History</router-link>
            </div>
        </div>
    </div>
</template>
<script>
import {mapState, mapGetters} from 'vuex'

import SplitButton from '../components/SplitButton'

import * as d3 from 'd3'
let x, y, zoom, xAxis, yAxis, bars;

const monthLabels = [
    '',
    'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
    ]

export default {
    name: 'progress-page',
    components: {SplitButton},
    data() {
        return {
            saveData: [],
            chartView: 'Yearly', 
        }
    },
    computed: {
        ...mapState(['goalInfo']),
        ...mapGetters(['activeSavingsAccount']),
        goalHeight() {
            let pct = this.activeSavingsAccount.balances[0].amount / this.goalInfo.amount

            return pct * 217.667
        },
    },
    methods: {
        historyChange(view) {
            this.chartView = view
            this.buildChart()
        },
        async getData() {
            this.saveData = await d3.json('https://fisential.com/fake-data/findata.json')

            this.saveData = this.saveData.slice(0, 365.25 * 2)
            this.buildChart()
        },

        buildChart() {
            let n = d3.nest()
                .key(item => {
                    let d = new Date(item.date)
                    if (this.chartView == 'Yearly') {
                        let m = d.getUTCMonth() + 1
                        if (m < 10) {
                            m = '0' + m
                        }
                        return `${d.getUTCFullYear()}-${m}`
                    }
                    // else if (this.chartView == 'Weekly') {
                    else {
                        let day = d.getUTCDate()
                        // let w = Math.ceil(day / 7)
                        let m = d.getUTCMonth() + 1
                        if (m < 10) {
                            m = '0' + m
                        }

                        if (day < 10) {
                            day = '0' + day
                        }

                        // return `${d.getUTCFullYear()}-${m}\nWeek ${w}`
                        return `${d.getUTCFullYear()}-${m}-${day}`
                        
                    }
                })
                .sortKeys(d3.ascending)
                .rollup(items => { 
                    return d3.sum(items, item => {
                        return item.amount
                    })
                })
                .entries(this.saveData)

            // console.log(n)
            let svg = d3.select(this.$refs.chart)

            svg.selectAll('g')
                .remove()

            let margin = {top: 20, right: 0, bottom: 30, left: 40};
            let w = this.$refs.chart.clientWidth
            let h = this.$refs.chart.clientHeight

            let fullw;
            if (this.chartView == 'Yearly') {
                fullw = (w - margin.left) * (n.length / 12)
            }
            else if (this.chartView == 'Monthly') {
                fullw = (w - margin.left) * (n.length / 30)
            }
            else if (this.chartView == 'Weekly') {
                fullw = (w - margin.left) * (n.length / 7)
            }

            zoom = d3.zoom()
                .scaleExtent([1, 1])
                .translateExtent([[0, 0], [fullw - margin.left, h - margin.bottom - margin.top]])
                .extent([[0, 0], [w - margin.left, h - margin.bottom - margin.top]])
                .on("zoom", this.zoomed);

            x = d3.scaleBand()
                .domain(n.map(d => d.key))
                .range([margin.left, Math.max(fullw, w - margin.right)])
                .padding(0.4)

            y = d3.scaleLinear()
                .domain([0, d3.max(n, d => d.value)]).nice()
                .range([h - margin.bottom, margin.top])

                
            xAxis = g => g
                .attr('transform', `translate(0, ${h - margin.bottom})`)
                .call(d3.axisBottom(x).tickSizeOuter(0))

            yAxis = g => g
                .attr('transform', `translate(${margin.left}, 0)`)
                .call(d3.axisLeft(y))

            bars = svg.append('g')
                .attr('fill', '#FF7E3A')
                .selectAll('rect')
                .data(n)
                .join('rect')
                    .attr('x', d => x(d.key))
                    .attr('y', d => y(d.value))
                    .attr('height', d => y(0) - y(d.value))
                    .attr('width', x.bandwidth())

            let last;
            svg.append('g')
                .attr('class', 'axis--x')
                .call(xAxis)
                .selectAll('.tick text')
                .call((text, w) => {
                    text.each((label, i, items) => {

                        let out = ''
                        let tnode = d3.select(items[i])
                        let parts = label.split('-')
                        if (this.chartView == 'Yearly') {
                            if (last != parts[0]) {
                                out = parts[0] + '\n' + monthLabels[parseInt(parts[1])]
                            }
                            else {
                                out = monthLabels[parseInt(parts[1])]
                            }

                            last = parts[0]
                        }
                        else {
                            if (last != parts[0] + parts[1]) {
                                out = parts[0] + '\n' + monthLabels[parseInt(parts[1])] + ' ' + parts[2]
                            }
                            else {
                                out = parts[2]
                            }

                            last = parts[0] + parts[1]
                        }

                        let lines = out.split('\n')

                        tnode = d3.select(items[i]).text(null)

                        let date = parseInt(parts[2])

                        if (this.chartView == 'Monthly' && (date % 5 != 0 || date == 30) && lines.length == 1) {
                            return;
                        }
                        for (let p of lines) {
                            tnode.append('tspan')
                            .attr('x', 0)
                            .attr('dy', '0.85em')
                            .text(p)
                        }
                    })
                }, x.bandwidth())

            svg.append('g')
                .attr('class', 'axis--y')
                .call(yAxis)
                .append('rect')
                    .attr('x', -margin.left)
                    .attr('y', 0)
                    .attr('width', margin.left)
                    .attr('height', h)
                    .attr('fill', 'white')
                    .lower()

            // d3.select('.axis--y').selectAll(".tick")
            //     .filter(function (d) {return d !== 0;})
            //     .append("path")
            //     .attr("class", "horizontalGrid")
            //     .attr('stroke', '#ccc')
            //     .attr('stroke-width', 1)
            //     .attr("d", "M 0 0 L " + w + " 0")
            //     .lower()

            svg.call(zoom);
            // zoom.translateTo(fullw, 0)

            svg.call(zoom.translateTo, fullw, 0)

        },
        zoomed () {
            let t = d3.event.transform
            if (bars) {
                bars.attr('transform', `translate(${t.x}, 0)`)
                d3.select(this.$refs.chart).select('.axis--x')
                    .attr('transform', `translate(${t.x}, ${this.$refs.chart.clientHeight - 30})`)
            }
        },
    },
    created() {
        this.getData()
    },
    
}
</script>
<style lang="scss">
#progress-page {
    display: flex;
    flex: 1 1 100%;
    flex-flow: column nowrap;
    background-image: linear-gradient(to bottom, #25e6bb 0%, #25e6bb 50%, #0a8de5 100%);

    .goal-panel {
        flex: 3 1 100%;
        padding: 32px 10px 48px;

        display: flex;
        flex-flow: column nowrap;

        h3 {
            margin-top: 0;
        }
        .goal-progress {
            flex: 1 1 100%;
            display: grid;
            grid-template-columns: 1fr 1fr;
            grid-template-rows: 100%;
            align-items: center;

            p {
                margin: 0;
                font-size: 12px;
                text-transform: uppercase;
                font-weight: bold;
            }
            output {
                display: block;
                margin-bottom: 16px;
                font-size: 18px;
                font-weight: 500;
            }
        }

    }
    .chart-panel {
        flex: 1 1 auto;
        padding: 16px 8px;
        background: white;

        display: flex;
        flex-flow: column nowrap;
        justify-content: space-between;

        .split-button {
            width: 100%;
            .button {
                font-size: 10px;
                text-transform: uppercase;
            }
            max-width: 300px;
            margin: 0 auto;
        }
        svg.chart {
            width: 95%;
        }
    }

    .edit, .btn .history {
        display: inline-block;
        color: black;
        background-image: linear-gradient(to bottom, #fff 0%, #fff 36%, #E8E8E8 100%);
        border-radius: 12px;

        font-weight: bold;
        text-shadow: 0 0 1px white;

        text-decoration: none;
        font-size: 14px;
        padding: 10px 20px;
    }

    .btn .history {
        background-image: linear-gradient(to bottom, #EBEBEB 0%, #EBEBEB 36%, #D6D6D6 100%);
    }

    .graphic text {
        font-size: 28px;
        // transform: translate(50%, 0%);
    }
    .no-goal-set p {
        margin: 16px 0;
    }
}
</style>
